module.exports = __webpack_public_path__ + "img/tt-active.acb8b3c7.png";